import { Create } from '@refinedev/antd'
import { useCreate, useGo } from '@refinedev/core'
import { Link } from 'react-router-dom'
import {
  Form,
  Input,
  Select,
  Card,
  Alert,
  Row,
  Col,
  Button,
  Space,
} from 'antd'
import {
  MailOutlined,
  UserOutlined,
  MedicineBoxOutlined,
} from '@ant-design/icons'

const { TextArea } = Input

const specialties = [
  { value: 'endocrinology', label: 'Endokrinologija' },
  { value: 'urology', label: 'Urologija' },
  { value: 'general', label: 'Opšta praksa' },
  { value: 'internal', label: 'Interna medicina' },
]

export default function DoctorInvitePage() {
  const [form] = Form.useForm()
  const go = useGo()
  const createMutation = useCreate()
  const isPending = createMutation.mutation.status === 'pending'
  const { mutate: createInvite } = createMutation

  const handleSubmit = (values: {
    email: string
    firstName: string
    lastName: string
    specialty: string
    message?: string
  }) => {
    createInvite(
      {
        resource: 'doctor-invites',
        values,
      },
      {
        onSuccess: () => {
          go({ to: '/doctors', type: 'push' })
        },
      }
    )
  }

  return (
    <Create
      title="Pozovi lekara"
      saveButtonProps={{
        loading: isPending,
        onClick: () => form.submit(),
      }}
      footerButtons={({ saveButtonProps }) => (
        <Space>
          <Link to="/doctors">
            <Button>Otkaži</Button>
          </Link>
          <Button
            type="primary"
            icon={<MailOutlined />}
            {...saveButtonProps}
          >
            Pošalji pozivnicu
          </Button>
        </Space>
      )}
    >
      <p style={{ marginBottom: 24, color: '#8c8c8c' }}>
        Pošaljite pozivnicu lekaru putem email-a. Lekar će moći da se prijavi koristeći svoj Google nalog.
      </p>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ specialty: 'general' }}
      >
        <Card title="Podaci o lekaru" style={{ marginBottom: 16 }}>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Ime"
                name="firstName"
                rules={[{ required: true, message: 'Unesite ime' }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Ime lekara"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Prezime"
                name="lastName"
                rules={[{ required: true, message: 'Unesite prezime' }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Prezime lekara"
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="Email adresa"
            name="email"
            rules={[
              { required: true, message: 'Unesite email adresu' },
              { type: 'email', message: 'Unesite validnu email adresu' },
            ]}
            extra="Pozivnica će biti poslata na ovu adresu. Lekar mora imati Google nalog povezan sa ovim email-om."
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="lekar@gmail.com"
            />
          </Form.Item>

          <Form.Item
            label="Specijalizacija"
            name="specialty"
            rules={[{ required: true, message: 'Izaberite specijalizaciju' }]}
          >
            <Select
              placeholder="Izaberite specijalizaciju"
              options={specialties}
              suffixIcon={<MedicineBoxOutlined />}
            />
          </Form.Item>

          <Form.Item
            label="Poruka (opciono)"
            name="message"
            extra="Dodatna poruka koja će biti uključena u email pozivnicu"
          >
            <TextArea
              rows={3}
              placeholder="Poštovani Dr..., pozivamo Vas da se pridružite našem timu..."
            />
          </Form.Item>
        </Card>
      </Form>

      <Alert
        type="info"
        showIcon
        message="Kako funkcioniše pozivnica"
        description={
          <ul style={{ margin: '8px 0 0 0', paddingLeft: 20 }}>
            <li>Lekar dobija email sa linkom za registraciju</li>
            <li>Prijava je moguća samo putem Google naloga</li>
            <li>Nakon prijave, lekar će imati pristup svojim pacijentima</li>
            <li>Admin može u bilo kom trenutku deaktivirati nalog</li>
          </ul>
        }
      />
    </Create>
  )
}
